
// Import module styles.
import "./edit.view.less";
